import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add test Param Mapping
function creatTestParamMapping(params: any) {
    const baseUrl = `/testParams/createTestParam`;
    return api.create(`${baseUrl}`, params);
}
// update Test Param Mapping
function updateTestParamMapping(params: any) {
    const baseUrl = '/testParams/updateTestParm';
    return api.update(`${baseUrl}`, params);
}

// get all test Param Mappings
function getAllTestParamMapping(params: any) {
    const baseUrl = '/testParams/getParamsJS';
    return api.create(`${baseUrl}`, params);
}

// get test Param Mapping
function getTestParamMapping(params: any) {
    const baseUrl = '/testParams/getParamsJS';
    return api.create(`${baseUrl}`, params);
}

// get test Param Listing
function getTestParamsListing(params: any) {
    const baseUrl = '/testParams/getParams';
    return api.create(`${baseUrl}`, params);
}

export {
    creatTestParamMapping,
    updateTestParamMapping,
    getAllTestParamMapping,
    getTestParamMapping,
    getTestParamsListing,
};
